import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogTitle, IconButton } from "@mui/material";
import { useState } from "react";

import { valueof } from "api/common/utils/type.utils";

import ConfirmContent from "./ModalContent/ConfirmContent";
import FormContent from "./ModalContent/FormContent";
import SubmissionContent from "./ModalContent/SubmissionContent";

interface ContactUsModalProps {
  open: boolean;
  onClose: () => void;
}

const PHASES = {
  CONFIRM: "confirm",
  FORM: "form",
  SUBMITTED: "submitted",
} as const;

type ModalPhase = valueof<typeof PHASES>;

const ContactUsModal = ({ open, onClose }: ContactUsModalProps) => {
  const [modalPhase, setModalPhase] = useState<ModalPhase>(PHASES.CONFIRM);
  const [ticket, setTicket] = useState("");

  const handleYes = () => {
    setModalPhase(PHASES.FORM);
  };

  const handleSubmitted = (ticketNumber: string) => {
    setTicket(ticketNumber);
    setModalPhase(PHASES.SUBMITTED);
  };

  const handleClose = () => {
    onClose();
  };

  const handleExited = () => {
    setModalPhase(PHASES.CONFIRM);
    setTicket("");
  };

  const modalWidth = modalPhase === PHASES.FORM ? "md" : "sm";
  return (
    // keepMounted prevents reCAPTCHA from being destroyed on close
    <Dialog
      open={open}
      maxWidth={modalWidth}
      fullWidth
      keepMounted
      onTransitionExited={handleExited}
      sx={{
        "& .MuiDialog-paper": {
          transition: "max-width 0.3s ease",
        },
      }}
    >
      <DialogTitle>
        Contact Us: NIAP/CCEVS
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {modalPhase === PHASES.CONFIRM && (
        <ConfirmContent onNo={handleClose} onYes={handleYes} />
      )}

      {/* Always mounted but hidden when not in form phase — keeps reCAPTCHA alive */}
      <FormContent
        onSubmitted={handleSubmitted}
        hidden={modalPhase !== PHASES.FORM}
      />

      {modalPhase === PHASES.SUBMITTED && <SubmissionContent ticket={ticket} />}
    </Dialog>
  );
};

export default ContactUsModal;
